const {createSlice} = require('@reduxjs/toolkit');

const orderSlice = createSlice({
    name: "order",
    initialState: {
        orderData: {},
        shippingPrice: 0,
    },
    reducers: {
        setOrderData(state, action) {
            state.orderData = action.payload;
        },
        setShippingPrice(state, action) {
            state.shippingPrice = action.payload;
        },
    },
});

export const {setOrderData, setShippingPrice} = orderSlice.actions;
export default orderSlice.reducer;
